/**
 * Step labels for the Create Customer multi-step form.
 * All in Slovak as per UX.
 */
export const CREATE_CUSTOMER_STEPS = [
  { id: 1, label: "Základné nastavenie zákazníka" },
  { id: 2, label: "Informácie o licencii" },
  { id: 3, label: "Lokalita" },
  { id: 4, label: "Kiosky" },
];
